import React from 'react'
import RedemptionFormPage from '../../components/Merchant/RedemptionForm';

const RedemptionForm = () => {
  return (
    <RedemptionFormPage />
  )
}

export default RedemptionForm;